import { useRef } from 'react';
import { IBKRStoreContext, createIBKRStores } from './store';
import type { IBKRStores } from './store';

export function IBKRStoreProvider({ children }: { children: React.ReactNode }) {
  const stores = useRef<IBKRStores | null>(null);
  if (!stores.current) {
    stores.current = createIBKRStores();
  }
  return (
    <IBKRStoreContext.Provider value={stores.current}>
      {children}
    </IBKRStoreContext.Provider>
  );
}
